import { c as t } from "../../../../index.esm-BeDSGXP5.js";
import { css as s } from "styled-components";
const o = {
  base: ({ theme: e }) => /* @__PURE__ */ s([
    "",
    " list-style-type:none;",
    ""
  ], e.resets.space, t({
    paddingLeft: [
      "xs",
      null,
      "sm"
    ]
  })),
  listItem: ({ variant: e }) => /* @__PURE__ */ s([
    "",
    " ",
    ""
  ], t({
    textAlign: "left",
    marginY: [
      "xs",
      null,
      "sm"
    ]
  }), e === "ordered" ? t({
    paddingLeft: [
      "xs",
      null,
      "sm"
    ]
  }) : t({
    listStyleType: "none"
  })),
  iconWrapper: ({ theme: e }) => /* @__PURE__ */ s([
    "",
    ""
  ], t({
    color: e.componentColors.list.icon,
    marginRight: [
      "xs",
      null,
      "sm"
    ]
  })),
  icon: () => /* @__PURE__ */ s([
    "vertical-align:top;"
  ]),
  ordered: ({ theme: e, listStyleType: l = "decimal" }) => /* @__PURE__ */ s([
    "li{list-style-type:",
    ";}",
    " li::marker{",
    " ",
    ";}"
  ], l, t({
    paddingLeft: [
      "md",
      null,
      "lg"
    ],
    marginLeft: "xs"
  }), e.components.text.base, e.components.text.medium)
};
export {
  o as default
};
